export const RechargeCardSalesData = [
  {
    network: "MTN",
    denomination: '100',
    serialNumber: "a10012a",
    quantity: 1000,
    price: 95,
    shop: "123456",
    customer: {
      phone_number: "08050910080",
    },
    agent: {
      id: "090ABC",
    },
    created_at: "May 21st 2024, 3:23:53 pm",
    date: {
      year: 2024,
      month: 5,
      day: 21,
    },
    status: 'sold'
  },
  {
    network: "MTN",
    denomination: '200',
    serialNumber: "a10012a",
    quantity: 1000,
    price: 195,
    shop: "123456",
    customer: {
      phone_number: "08050910080",
    },
    agent: {
      id: "090ABC",
    },
    created_at: "May 21st 2024, 3:23:53 pm",
    date: {
      year: 2024,
      month: 5,
      day: 21,
    },
    status: 'sold'
  },
  {
    network: "MTN",
    denomination: '400',
    serialNumber: "a10012a",
    quantity: 1000,
    price: 395,
    shop: "123456",
    customer: {
      phone_number: "08050910080",
    },
    agent: {
      id: "090ABC",
    },
    created_at: "May 21st 2024, 3:23:53 pm",
    date: {
      year: 2024,
      month: 5,
      day: 21,
    },
    status: 'sold'
  },
  {
    network: "MTN",
    denomination: '500',
    serialNumber: "a10012a",
    quantity: 1000,
    price: 495,
    shop: "123456",
    customer: {
      phone_number: "08050910080",
    },
    agent: {
      id: "090ABC",
    },
    created_at: "May 21st 2024, 3:23:53 pm",
    date: {
      year: 2024,
      month: 5,
      day: 21,
    },
    status: 'sold'
  },
  {
    network: "MTN",
    denomination: '1000',
    serialNumber: "a10012a",
    quantity: 1000,
    price: 995,
    shop: "123456",
    customer: {
      phone_number: "08050910080",
    },
    agent: {
      id: "090ABC",
    },
    created_at: "May 21st 2024, 3:23:53 pm",
    date: {
      year: 2024,
      month: 5,
      day: 21,
    },
    status: 'sold'
  },
  {
    network: "AIRTEL",
    denomination: '100',
    serialNumber: "a10012a",
    quantity: 1000,
    price: 95,
    shop: "123456",
    customer: {
      phone_number: "08050910080",
    },
    agent: {
      id: "090ABC",
    },
    created_at: "May 21st 2024, 3:23:53 pm",
    date: {
      year: 2024,
      month: 5,
      day: 21,
    },
    status: 'sold'
  },
  {
    network: "AIRTEL",
    denomination: '200',
    serialNumber: "a10012a",
    quantity: 1000,
    price: 195,
    shop: "123456",
    customer: {
      phone_number: "08050910080",
    },
    agent: {
      id: "090ABC",
    },
    created_at: "May 21st 2024, 3:23:53 pm",
    date: {
      year: 2024,
      month: 5,
      day: 21,
    },
    status: 'sold'
  },
  {
    network: "AIRTEL",
    denomination: '500',
    serialNumber: "a10012a",
    quantity: 1000,
    price: 495,
    shop: "123456",
    customer: {
      phone_number: "08050910080",
    },
    agent: {
      id: "090ABC",
    },
    created_at: "May 21st 2024, 3:23:53 pm",
    date: {
      year: 2024,
      month: 5,
      day: 21,
    },
    status: 'sold'
  },
  {
    network: "AIRTEL",
    denomination: '1000',
    serialNumber: "a10012a",
    quantity: 1000,
    price: 995,
    shop: "123456",
    customer: {
      phone_number: "08050910080",
    },
    agent: {
      id: "090ABC",
    },
    created_at: "May 21st 2024, 3:23:53 pm",
    date: {
      year: 2024,
      month: 5,
      day: 21,
    },
    status: 'sold'
  },
  {
    network: "GLO",
    denomination: '100',
    serialNumber: "a10012a",
    quantity: 1000,
    price: 95,
    shop: "123456",
    customer: {
      phone_number: "08050910080",
    },
    agent: {
      id: "090ABC",
    },
    created_at: "May 21st 2024, 3:23:53 pm",
    date: {
      year: 2024,
      month: 5,
      day: 21,
    },
    status: 'sold'
  },
  {
    network: "GLO",
    denomination: '200',
    serialNumber: "a10012a",
    quantity: 1000,
    price: 195,
    shop: "123456",
    customer: {
      phone_number: "08050910080",
    },
    agent: {
      id: "090ABC",
    },
    created_at: "May 21st 2024, 3:23:53 pm",
    date: {
      year: 2024,
      month: 5,
      day: 21,
    },
    status: 'sold'
  },
  {
    network: "GLO",
    denomination: '500',
    serialNumber: "a10012a",
    quantity: 1000,
    price: 495,
    shop: "123456",
    customer: {
      phone_number: "08050910080",
    },
    agent: {
      id: "090ABC",
    },
    created_at: "May 21st 2024, 3:23:53 pm",
    date: {
      year: 2024,
      month: 5,
      day: 21,
    },
    status: 'sold'
  },
  {
    network: "GLO",
    denomination: '1000',
    serialNumber: "a10012a",
    quantity: 1000,
    price: 995,
    shop: "123456",
    customer: {
      phone_number: "08050910080",
    },
    agent: {
      id: "090ABC",
    },
    created_at: "May 21st 2024, 3:23:53 pm",
    date: {
      year: 2024,
      month: 5,
      day: 21,
    },
    status: 'sold'
  },
  {
    network: "9MOBILE",
    denomination: '100',
    serialNumber: "a10012a",
    quantity: 1000,
    price: 95,
    shop: "123456",
    customer: {
      phone_number: "08050910080",
    },
    agent: {
      id: "090ABC",
    },
    created_at: "May 21st 2024, 3:23:53 pm",
    date: {
      year: 2024,
      month: 5,
      day: 21,
    },
    status: 'sold'
  },
  {
    network: "9MOBILE",
    denomination: '200',
    serialNumber: "a10012a",
    quantity: 1000,
    price: 195,
    shop: "123456",
    customer: {
      phone_number: "08050910080",
    },
    agent: {
      id: "090ABC",
    },
    created_at: "May 21st 2024, 3:23:53 pm",
    date: {
      year: 2024,
      month: 5,
      day: 21,
    },
    status: 'sold'
  },
  {
    network: "9MOBILE",
    denomination: '500',
    serialNumber: "a10012a",
    quantity: 1000,
    price: 495,
    shop: "123456",
    customer: {
      phone_number: "08050910080",
    },
    agent: {
      id: "090ABC",
    },
    created_at: "May 21st 2024, 3:23:53 pm",
    date: {
      year: 2024,
      month: 5,
      day: 21,
    },
    status: 'sold'
  },
  {
    network: "9MOBILE",
    denomination: '1000',
    serialNumber: "a10012a",
    quantity: 1000,
    price: 995,
    shop: "123456",
    customer: {
      phone_number: "08050910080",
    },
    agent: {
      id: "090ABC",
    },
    created_at: "May 21st 2024, 3:23:53 pm",
    date: {
      year: 2024,
      month: 5,
      day: 21,
    },
    status: 'sold'
  },
];

export const SalesAgentData = [
  {
    id: "090ABC",
    name: "Abdullahi Isa",
    phone_number: "08123456789",
    email: 'abisa24@gmail.com',
    shop: "123456",
  },
];

export const CustomersData = [
  {
    name: "Abubakar Abdu",
    phone_number: "08050910080",
    email: "ababdu126@gmail.com",
    whatsApp: "08050910080",
    state: 'Kano',
    lga: 'KMC',
    address: "No. 6 Dorayi Babba",
    
  },
];

export const SalesShops = [
  { id: "123456", name: "Fantel Kabuga", address: "No. 6 Kabuga" },
];

export const DailyDenomSales = [
  { day: 1, month: 5, year: 2024, network: "MTN", denomination: '100', purchasing_price: 90, selling_price: 95, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { day: 1, month: 5, year: 2024, network: "MTN", denomination: '200', purchasing_price: 190, selling_price: 195, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { day: 1, month: 5, year: 2024, network: "MTN", denomination: '400', purchasing_price: 395, selling_price: 397, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { day: 1, month: 5, year: 2024, network: "MTN", denomination: '500', purchasing_price: 492, selling_price: 496, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { day: 1, month: 5, year: 2024, network: "MTN", denomination: '1000',purchasing_price: 985, selling_price: 990,  salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { day: 1, month: 5, year: 2024, network: "GLO", denomination: '100', purchasing_price: 91, selling_price: 95, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { day: 1, month: 5, year: 2024, network: "GLO", denomination: '200', purchasing_price: 185, selling_price: 195, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { day: 1, month: 5, year: 2024, network: "GLO", denomination: '500', purchasing_price: 480, selling_price: 492, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { day: 1, month: 5, year: 2024, network: "GLO", denomination: '1000',purchasing_price: 980, selling_price: 990,  salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { day: 1, month: 5, year: 2024, network: "AIRTEL", denomination: '100', purchasing_price: 89, selling_price: 94, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { day: 1, month: 5, year: 2024, network: "AIRTEL", denomination: '200', purchasing_price: 185, selling_price: 195, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { day: 1, month: 5, year: 2024, network: "AIRTEL", denomination: '500', purchasing_price: 475, selling_price: 490, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { day: 1, month: 5, year: 2024, network: "AIRTEL", denomination: '1000',purchasing_price: 978, selling_price: 988,  salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { day: 1, month: 5, year: 2024, network: "9MOBILE", denomination: '100', purchasing_price: 90, selling_price: 95, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { day: 1, month: 5, year: 2024, network: "9MOBILE", denomination: '200', purchasing_price: 188, selling_price: 198, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { day: 1, month: 5, year: 2024, network: "9MOBILE", denomination: '500', purchasing_price: 489, selling_price: 496, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { day: 1, month: 5, year: 2024, network: "9MOBILE", denomination: '1000',purchasing_price: 987, selling_price: 987,  salesCount: 92590, location: "kano", shop: "Zoo Road" },
];

export const WeeklyDenomSales = [
  { week: 1, month: 5, year: 2024, network: "MTN", denomination: '100', purchasing_price: 90, selling_price: 95, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { week: 1, month: 5, year: 2024, network: "MTN", denomination: '200', purchasing_price: 190, selling_price: 195, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { week: 1, month: 5, year: 2024, network: "MTN", denomination: '400', purchasing_price: 395, selling_price: 397, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { week: 1, month: 5, year: 2024, network: "MTN", denomination: '500', purchasing_price: 492, selling_price: 496, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { week: 1, month: 5, year: 2024, network: "MTN", denomination: '1000',purchasing_price: 985, selling_price: 990,  salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { week: 1, month: 5, year: 2024, network: "GLO", denomination: '100', purchasing_price: 91, selling_price: 95, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { week: 1, month: 5, year: 2024, network: "GLO", denomination: '200', purchasing_price: 185, selling_price: 195, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { week: 1, month: 5, year: 2024, network: "GLO", denomination: '500', purchasing_price: 480, selling_price: 492, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { week: 1, month: 5, year: 2024, network: "GLO", denomination: '1000',purchasing_price: 980, selling_price: 990,  salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { week: 1, month: 5, year: 2024, network: "AIRTEL", denomination: '100', purchasing_price: 89, selling_price: 94, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { week: 1, month: 5, year: 2024, network: "AIRTEL", denomination: '200', purchasing_price: 185, selling_price: 195, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { week: 1, month: 5, year: 2024, network: "AIRTEL", denomination: '500', purchasing_price: 475, selling_price: 490, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { week: 1, month: 5, year: 2024, network: "AIRTEL", denomination: '1000',purchasing_price: 978, selling_price: 988,  salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { week: 1, month: 5, year: 2024, network: "9MOBILE", denomination: '100', purchasing_price: 90, selling_price: 95, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { week: 1, month: 5, year: 2024, network: "9MOBILE", denomination: '200', purchasing_price: 188, selling_price: 198, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { week: 1, month: 5, year: 2024, network: "9MOBILE", denomination: '500', purchasing_price: 489, selling_price: 496, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { week: 1, month: 5, year: 2024, network: "9MOBILE", denomination: '1000',purchasing_price: 987, selling_price: 987,  salesCount: 92590, location: "kano", shop: "Zoo Road" },
];
export const MonthlyDenomSales = [
  { month: 5, year: 2024, network: "MTN", denomination: '100', purchasing_price: 90, selling_price: 95, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { month: 5, year: 2024, network: "MTN", denomination: '200', purchasing_price: 190, selling_price: 195, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { month: 5, year: 2024, network: "MTN", denomination: '400', purchasing_price: 395, selling_price: 397, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { month: 5, year: 2024, network: "MTN", denomination: '500', purchasing_price: 492, selling_price: 496, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { month: 5, year: 2024, network: "MTN", denomination: '1000',purchasing_price: 985, selling_price: 990,  salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { month: 5, year: 2024, network: "GLO", denomination: '100', purchasing_price: 91, selling_price: 95, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { month: 5, year: 2024, network: "GLO", denomination: '200', purchasing_price: 185, selling_price: 195, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { month: 5, year: 2024, network: "GLO", denomination: '500', purchasing_price: 480, selling_price: 492, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { month: 5, year: 2024, network: "GLO", denomination: '1000',purchasing_price: 980, selling_price: 990,  salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { month: 5, year: 2024, network: "AIRTEL", denomination: '100', purchasing_price: 89, selling_price: 94, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { month: 5, year: 2024, network: "AIRTEL", denomination: '200', purchasing_price: 185, selling_price: 195, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { month: 5, year: 2024, network: "AIRTEL", denomination: '500', purchasing_price: 475, selling_price: 490, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { month: 5, year: 2024, network: "AIRTEL", denomination: '1000',purchasing_price: 978, selling_price: 988,  salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { month: 5, year: 2024, network: "9MOBILE", denomination: '100', purchasing_price: 90, selling_price: 95, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { month: 5, year: 2024, network: "9MOBILE", denomination: '200', purchasing_price: 188, selling_price: 198, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { month: 5, year: 2024, network: "9MOBILE", denomination: '500', purchasing_price: 489, selling_price: 496, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  { month: 5, year: 2024, network: "9MOBILE", denomination: '1000',purchasing_price: 987, selling_price: 987,  salesCount: 92590, location: "kano", shop: "Zoo Road" },
];
export const AnnuallyDenomSales = [
  {year: 2024, network: "MTN", denomination: '100', purchasing_price: 90, selling_price: 95, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  {year: 2024, network: "MTN", denomination: '200', purchasing_price: 190, selling_price: 195, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  {year: 2024, network: "MTN", denomination: '400', purchasing_price: 395, selling_price: 397, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  {year: 2024, network: "MTN", denomination: '500', purchasing_price: 492, selling_price: 496, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  {year: 2024, network: "MTN", denomination: '1000',purchasing_price: 985, selling_price: 990,  salesCount: 92590, location: "kano", shop: "Zoo Road" },
  {year: 2024, network: "GLO", denomination: '100', purchasing_price: 91, selling_price: 95, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  {year: 2024, network: "GLO", denomination: '200', purchasing_price: 185, selling_price: 195, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  {year: 2024, network: "GLO", denomination: '500', purchasing_price: 480, selling_price: 492, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  {year: 2024, network: "GLO", denomination: '1000',purchasing_price: 980, selling_price: 990,  salesCount: 92590, location: "kano", shop: "Zoo Road" },
  {year: 2024, network: "AIRTEL", denomination: '100', purchasing_price: 89, selling_price: 94, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  {year: 2024, network: "AIRTEL", denomination: '200', purchasing_price: 185, selling_price: 195, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  {year: 2024, network: "AIRTEL", denomination: '500', purchasing_price: 475, selling_price: 490, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  {year: 2024, network: "AIRTEL", denomination: '1000',purchasing_price: 978, selling_price: 988,  salesCount: 92590, location: "kano", shop: "Zoo Road" },
  {year: 2024, network: "9MOBILE", denomination: '100', purchasing_price: 90, selling_price: 95, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  {year: 2024, network: "9MOBILE", denomination: '200', purchasing_price: 188, selling_price: 198, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  {year: 2024, network: "9MOBILE", denomination: '500', purchasing_price: 489, selling_price: 496, salesCount: 92590, location: "kano", shop: "Zoo Road" },
  {year: 2024, network: "9MOBILE", denomination: '1000',purchasing_price: 987, selling_price: 987,  salesCount: 92590, location: "kano", shop: "Zoo Road" },
];

export const DailyGeneralSales = [
  { day: 1, month: 5, year: 2024, network: "MTN", salesCount: 92590, revenue: 1067890, profit: 123456789, lost: 0, lostCount: 0 },
  { day: 1, month: 5, year: 2024, network: "GLO", salesCount: 32590, revenue: 567890, profit: 123456789, lost: 0, lostCount: 0  },
  { day: 1, month: 5, year: 2024, network: "AIRTEL", salesCount: 52590, revenue: 367890, profit: 123456789, lost: 0, lostCount: 0  },
  { day: 1, month: 5, year: 2024, network: "9MOBILE", salesCount: 12590, revenue: 167890, profit: 123456789, lost: 0, lostCount: 0  },
];
export const WeeklyGeneralSales = [
  { week: 1, month: 5, year: 2024, network: "MTN", salesCount: 92590, revenue: 1067890, profit: 123456789, lost: 0, lostCount: 0 },
  { week: 1, month: 5, year: 2024, network: "GLO", salesCount: 32590, revenue: 567890, profit: 123456789, lost: 0, lostCount: 0  },
  { week: 1, month: 5, year: 2024, network: "AIRTEL", salesCount: 52590, revenue: 367890, profit: 123456789, lost: 0, lostCount: 0  },
  { week: 1, month: 5, year: 2024, network: "9MOBILE", salesCount: 12590, revenue: 167890, profit: 123456789, lost: 0, lostCount: 0  },
];
export const MonthlyGeneralSales = [
  { month: 5, year: 2024, network: "MTN", salesCount: 92590, revenue: 1067890, profit: 123456789, lost: 0, lostCount: 0  },
  { month: 5, year: 2024, network: "GLO", salesCount: 32590, revenue: 567890, profit: 123456789, lost: 0, lostCount: 0  },
  { month: 5, year: 2024, network: "AIRTEL", salesCount: 52590, revenue: 367890, profit: 123456789, lost: 0, lostCount: 0  },
  { month: 5, year: 2024, network: "9MOBILE", salesCount: 12590, revenue: 167890, profit: 123456789, lost: 0, lostCount: 0  },
];
export const AnnuallyGeneralSales = [
  { year: 2024, network: "MTN", salesCount: 92590, revenue: 1067890, profit: 123456789, lost: 0, lostCount: 0  },
  { year: 2024, network: "GLO", salesCount: 32590, revenue: 567890, profit: 123456789, lost: 0, lostCount: 0  },
  { year: 2024, network: "AIRTEL", salesCount: 52590, revenue: 367890, profit: 123456789, lost: 0, lostCount: 0  },
  { year: 2024, network: "9MOBILE", salesCount: 12590, revenue: 167890, profit: 123456789, lost: 0, lostCount: 0  },
];